import { render, staticRenderFns } from "./softwareDocStructure.vue?vue&type=template&id=68290585&"
import script from "./softwareDocStructure.vue?vue&type=script&lang=js&"
export * from "./softwareDocStructure.vue?vue&type=script&lang=js&"
import style0 from "./softwareDocStructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports